import React from "react"
import Player from "./player"
import {Container, Row, Col} from 'reactstrap'

class Multiplayer extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            episodes: props.episodes,
            currentEpisode: props.episodes[0].node
        }
        this.episodeSelected = this.episodeSelected.bind(this);
    }

    episodeSelected(e){
        console.log(e.target.dataset.episode);
        let targetEpisode =this.state.episodes.filter(e2 => e.target.dataset.episode === e2.node.fields.slug)[0].node;
        this.setState({currentEpisode: targetEpisode, episodes: this.state.episodes})
    }

    render(){
        return (
            <Container>
                <Row>
                    <Col>
                        {this.state.currentEpisode.frontmatter.title}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Player src={this.state.currentEpisode.fields.episodeMp3Url}/>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ul className="episodeList">
                        {this.state.episodes.map((e)=>(
                            <li data-episode={e.node.fields.slug} 
                                onClick={this.episodeSelected} 
                                key={e.node.fields.slug}
                                className={e.node===this.state.currentEpisode ? 'selected': ''}>
                                {e.node.frontmatter.title} - {e.node.fields.episodeDuration}
                            </li>
                        ))}
                        </ul>
                    </Col>
                </Row>
                
            </Container> 
        )
    }
}

export default Multiplayer